import { render, staticRenderFns } from "./account-disable-modal.vue?vue&type=template&id=a98db694&scoped=true"
import script from "./account-disable-modal.vue?vue&type=script&lang=js"
export * from "./account-disable-modal.vue?vue&type=script&lang=js"
import style0 from "./account-disable-modal.vue?vue&type=style&index=0&id=a98db694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98db694",
  null
  
)

export default component.exports